import { IApplicationState } from '../../types/redux';

export function getDisplayName(state: IApplicationState) {
  return state.newbuilding.displayName;
}
